/*
Monotype Foundry Platform API
Version 1.0.0

Definition: SecretCodeUnique

Properties:
  isUnique: boolean
  secretCode: string
*/

var SecretCodeUnique = (function () {
  function validateSecretCodeUnique (arg) {
    // Validate isUnique
    if (arg.isUnique && !(typeof arg.isUnique === 'boolean')) {
      throw new Error('SecretCodeUnique.isUnique: Wrong type: Got \'' + (typeof arg.isUnique) + '\', but expected: \'boolean\'')
    }
    // Validate secretCode
    if (arg.secretCode && !(typeof arg.secretCode === 'string')) {
      throw new Error('SecretCodeUnique.secretCode: Wrong type: Got \'' + (typeof arg.secretCode) + '\', but expected: \'string\'')
    }
  }
  function buildSecretCodeUnique (arg) {
    var SecretCodeUnique = arg
    // Complete isUnique
    // Expected Type: boolean
    SecretCodeUnique.isUnique = SecretCodeUnique.isUnique || false
    // Complete secretCode
    // Expected Type: string
    SecretCodeUnique.secretCode = SecretCodeUnique.secretCode || ''
    return SecretCodeUnique
  }
  return {
    validate: validateSecretCodeUnique,
    build: buildSecretCodeUnique
  }
})()

module.exports = SecretCodeUnique
